import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'app-html-snackbar',
    standalone: true,
    imports: [CommonModule, MatButtonModule],
    template: `
        <div class="flex items-start gap-2 w-full max-w-[500px]">
            <div class="flex-1 min-w-0 break-words whitespace-normal" [innerHTML]="data?.message"></div>
            <button
                class="shrink-0 self-start text-white min-w-0 p-0 w-5 h-5 leading-none"
                mat-button
                type="button"
                aria-label="Close"
                (click)="dismiss()">
                x
            </button>
        </div>
    `
})
export class HtmlSnackbarComponent {
    constructor(
        @Inject(MAT_SNACK_BAR_DATA) public data: { message: string },
        private _snackBarRef: MatSnackBarRef<HtmlSnackbarComponent>
    ) { }

    dismiss(): void {
        this._snackBarRef.dismiss();
    }
}
